import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateContainerTypeInformationAdminMutationVariables = Types.Exact<{
  container_types: Array<Types.AdminContainerTypeInput> | Types.AdminContainerTypeInput;
}>;


export type UpdateContainerTypeInformationAdminMutation = { __typename?: 'Mutation', updateContainerTypeInformationAdmin: Array<{ __typename?: 'AdminContainerType', id: number, name?: string | null, names_by_language_string: string, class: string, order_key: number, icon_url?: string | null, size_helper?: string | null, image_url?: string | null, country_codes: Array<string>, hex_code?: string | null, packing_unit: number, group_id?: number | null, sku?: string | null, branding?: string | null, legal_owner?: string | null, packing_instructions?: string | null, weight: number, archived: boolean, segment?: string | null, container_equivalent_type_ids: Array<number>, container_equivalents_id?: number | null }> };


export const UpdateContainerTypeInformationAdminDocument = gql`
    mutation UpdateContainerTypeInformationAdmin($container_types: [AdminContainerTypeInput!]!) {
  updateContainerTypeInformationAdmin(container_types: $container_types) {
    id
    name
    names_by_language_string
    class
    order_key
    icon_url
    size_helper
    image_url
    country_codes
    hex_code
    packing_unit
    group_id
    sku
    branding
    legal_owner
    packing_instructions
    weight
    archived
    segment
    container_equivalent_type_ids
    container_equivalents_id
  }
}
    `;
export type UpdateContainerTypeInformationAdminMutationFn = Apollo.MutationFunction<UpdateContainerTypeInformationAdminMutation, UpdateContainerTypeInformationAdminMutationVariables>;

/**
 * __useUpdateContainerTypeInformationAdminMutation__
 *
 * To run a mutation, you first call `useUpdateContainerTypeInformationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContainerTypeInformationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContainerTypeInformationAdminMutation, { data, loading, error }] = useUpdateContainerTypeInformationAdminMutation({
 *   variables: {
 *      container_types: // value for 'container_types'
 *   },
 * });
 */
export function useUpdateContainerTypeInformationAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContainerTypeInformationAdminMutation, UpdateContainerTypeInformationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContainerTypeInformationAdminMutation, UpdateContainerTypeInformationAdminMutationVariables>(UpdateContainerTypeInformationAdminDocument, options);
      }
export type UpdateContainerTypeInformationAdminMutationHookResult = ReturnType<typeof useUpdateContainerTypeInformationAdminMutation>;
export type UpdateContainerTypeInformationAdminMutationResult = Apollo.MutationResult<UpdateContainerTypeInformationAdminMutation>;
export type UpdateContainerTypeInformationAdminMutationOptions = Apollo.BaseMutationOptions<UpdateContainerTypeInformationAdminMutation, UpdateContainerTypeInformationAdminMutationVariables>;